import templateManifest from "../../../../templates/manifest.json";
import type { AppEntry } from "./AppDetailModal";

export const APP_CATALOG: AppEntry[] = templateManifest;
